export const NEWSLETTER_POPUP = 'newsletter_popup';

export const TWO_DAYS_IN_SECONDS = 172800000;

export const NEWSLETTER_DELAY = 15000; // 9 sec
export const NEWSLETTER_SOFT_CLOSE = 86400000; // 1 day
export const NEWSLETTER_HARD_CLOSE = 15778800000; // 6 months
